var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00016 6.66667H1.3335V2.66862C1.3335 2.29935 1.63704 2 1.9947 2H14.0056C14.3708 2 14.6668 2.29192 14.6668 2.66862V6.66667H14.0002V13.3343C14.0002 13.702 13.7036 14 13.3379 14H2.66243C2.29667 14 2.00016 13.7017 2.00016 13.3343V6.66667ZM12.6668 6.66667H3.3335V12.6667H12.6668V6.66667ZM2.66683 3.33333V5.33333H13.3335V3.33333H2.66683ZM6.00016 8H10.0002V9.33333H6.00016V8Z",
    fill: "#F73B58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.7edc365c9e7b182a37ca6031abbb7020.svg";
export { ForwardRef as ReactComponent };